export enum TransactionExpandEnum {
  LogEmails = "logEmails",
  IsVoidable = "isVoidable",
  IsReversible = "isReversible",
  IsRefundable = "isRefundable",
  IsCompletable = "isCompletable",
  IsSettled = "isSettled",
  CreatedUser = "createdUser",
  Location = "location",
  Contact = "contact",
  Changelogs = "changelogs",
  ProductTransaction = "productTransaction",
  Tags = "tags",
  AllTags = "allTags",
  Recurring = "recurring",
  TagTransactions = "tagTransactions",
  DeclinedRecurringNotification = "declinedRecurringNotification",
  PaymentRecurringNotification = "paymentRecurringNotification",
  AccountVault = "accountVault",
  QuickInvoice = "quickInvoice",
  DeveloperCompany = "developerCompany",
  Terminal = "terminal",
  HostedPaymentPage = "hostedPaymentPage",
  TransactionLevel3 = "transactionLevel3",
  DeveloperCompanyId = "developerCompanyId",
  TransactionHistories = "transactionHistories",
  SurchargeTransaction = "surchargeTransaction",
  Surcharge = "surcharge",
  Signature = "signature",
  ReasonCode = "reasonCode",
  Type = "type",
  Status = "status",
  TransactionBatch = "transactionBatch",
  TransactionSplits = "transactionSplits",
  PostbackLogs = "postbackLogs",
  CurrencyType = "currencyType",
  TransactionReferences = "transactionReferences",
  SavedAccount = "savedAccount",
  RejectedTransactionAchRetries = "rejectedTransactionAchRetries",
  ReturnFeeTransactionAchRetry = "returnFeeTransactionAchRetry",
  RetryTransactionAchRetry = "retryTransactionAchRetry",
  IsRetriable = "isRetriable"
}
